
import {
  Div,
  Text,
  Modal,
  // @ts-ignore
} from 'atomize';

export const WrongNetworkModal = () => {
  return (
    <Modal isOpen={true} align="start" rounded="md" bg="lightest">
      <Div d="flex" justify="center">
        <Text textSize="subheader" align="center">
          Please switch to mainnet.
        </Text>
      </Div>
    </Modal>
  )
}